import { FrameLevelCellid, Point, Rectangle, Size } from "../util";
import { numberLiteralTypeAnnotation } from "@babel/types";

//	.............    ......................
//	.rW         .    .rL                  .
//	.           .    .                    .
//	.    x pW   .    .       x pL         .
//	.           .    .                    .	BR bottomRight
//	.............    ......................	TL topLeft
//	(pW - rW.TL) / (rW.BR - pW) = (pL - rL.TL) / (rL.BR - pL)
//
//	(pW - rW.TL) x (rL.BR - pL) = (rW.BR - pW) x (pL - rL.TL)
//
//	((pW - rW.TL) x rL.BR) - ((pW - rW.TL) x pL) =
//	((rW.BR - pW) x pL) - ((rW.BR - pW) x rL.TL))
//
//	((pW - rW.TL) x rL.BR) + ((rW.BR - pW) x rL.TL)) =
//	((pW - rW.TL) x pL) + ((rW.BR - pW) x pL) =
//	(rW.TL + rW.BR) x pL
//
//	pL = (((pW - rW.TL) x rL.BR) + ((rW.BR - pW) x rL.TL)) / (rW.TL + rW.BR)
//	   = ((pW x rL.BR) - (rW.TL x rL.BR) + ((rW.BR - pW) x rL.TL)) / (rW.TL + rW.BR)
//	   = (pW * (rL.BR - rL.TL) + (rW.BR * rL.TL) - (rW.TL * rL.BR)) / (rW.BR - rW.TL)
//
//	pL= (pW * a +b)/c
//	pW= (pL * c -b)/a
//	a= rL.BR - rL.TL
//	b= (rW.BR * rL.TL) - (rW.TL * rL.BR)
//	c= rW.BR - rW.TL

export class TrWL {
  public m_rL: Rectangle;
  public m_rW: Rectangle;
  public m_aX: number;
  public m_aY: number;
  public m_bX: number;
  public m_bY: number;
  public m_cX: number;
  public m_cY: number;
  constructor(rW: Rectangle, rL: Rectangle) {
    this.m_rW = rW;
    this.m_rL = rL;
    //	a= rL.BR - rL.TL
    this.m_aX = rL.right - rL.left;
    this.m_aY = rL.bottom - rL.top;
    //	b= (rW.BR * rL.TL) - (rW.TL * rL.BR)
    this.m_bX = rW.right * rL.left - rW.left * rL.right;
    this.m_bY = rW.bottom * rL.top - rW.top * rL.bottom;
    //	c= rW.BR - rW.TL
    this.m_cX = rW.right - rW.left;
    this.m_cY = rW.bottom - rW.top;
  }

  // 指定したWorldのpointをLocalに投影する
  public getPointL(pW: Point): Point {
    // pL= (pW * a +b)/c
    let x = (pW.x * this.m_aX + this.m_bX) / this.m_cX;
    let y = (pW.y * this.m_aY + this.m_bY) / this.m_cY;
    return new Point(x, y);
  }

  // 指定したLocalのpointをWorldに投影する
  public getPointW(pL: Point): Point {
    //	pW= (pL * c -b)/a
    let x = (pL.x * this.m_cX - this.m_bX) / this.m_aX;
    let y = (pL.y * this.m_cY - this.m_bY) / this.m_aY;
    return new Point(x, y);
  }

  public getLocal(rW: Rectangle): Rectangle {
    let topLeftW = rW.topLeft;
    let bottomRightW = rW.bottomRight;

    let topLeftL = this.getPointL(topLeftW);
    let bottomRightL = this.getPointL(bottomRightW);

    return new Rectangle(
      topLeftL.x,
      topLeftL.y,
      bottomRightL.x,
      bottomRightL.y,
    );
  }

  public getWorld(rL: Rectangle): Rectangle {
    let topLeftL = rL.topLeft;
    let bottomRightL = rL.bottomRight;

    let topLeftW = this.getPointW(topLeftL);
    let bottomRightW = this.getPointW(bottomRightL);

    return new Rectangle(
      topLeftW.x,
      topLeftW.y,
      bottomRightW.x,
      bottomRightW.y,
    );
  }
}

export class PreviewDaishi {
  /** 保持しているレベルの最大値 */
  readonly levelMax: number;

  /** 各セルのサイズ */
  readonly cellSize: Size;
  //readonly _szCell: Size;

  /** プレビュー台紙のサイズ */
  readonly size: Size;
  //readonly bfRectVV: Rectangle;

  /** ViewDBの分割数 */
  readonly splitCnt: { x: number; y: number };
  //readonly szBunkatu: Size;

  /** レベルごとの セル ２次元配列 */
  //readonly cellMatrixHash: { [key: number]: Cell[][] };

  /**
   * 表示倍率に対するバッファ
   *
   * @description
   * 値を小さくすれば表示スピードが向上するが、出力される画像が荒くなる
   * 性能に応じて調整するべき。
   */
  public readonly magnificationBuffer: number = 1.3;

  /**
   * 初期表示時のレベル
   * @todo: 本来は台紙ごとに選択可能とするべき
   */
  private readonly INIT_LEVEL: number = 0;

  public toString(): string {
    return `{
      levelMax: ${this.levelMax},
      cellSize: ${this.cellSize},
      size: ${this.size},
			splitCnt: ${JSON.stringify(this.splitCnt)}
    }`;
  }

  private tFrameLast: Rectangle;
  private fFrameLast: Rectangle;

  constructor(
    size: Size,
    levelMax: number,
    cellSize: Size,
    splitCnt: { x: number; y: number },
  );
  constructor(text: string);
  constructor(
    arg1: Size | string,
    levelMax?: number,
    cellSize?: Size,
    splitCnt?: { x: number; y: number },
  ) {
    if (arg1 instanceof Size) {
      this.size = arg1;
      this.levelMax = levelMax as number;
      this.cellSize = cellSize as Size;
      this.splitCnt = splitCnt as { x: number; y: number };
    } else {
      let size: Size = new Size(0, 0);
      let levelMax: number = 0;
      let cellSize: Size = new Size(0, 0);
      let splitCnt: { x: number; y: number } = { x: 0, y: 0 };
      arg1.split("\n").forEach((line: string) => {
        if (line === "") return;
        line = line.trim();
        const cols: string[] = line.split(" ");
        const label: string = cols[0];

        //if ('m_bfRectVV' === label) {
        //    const s1 = cols[1].split(',');
        //    const s2 = cols[2].split(',');
        //    bfRectVV = new Rectangle(
        //				new Point(Number(s1[0]),Number(s1[1])),
        //				new Size(Number(s2[0]),Number(s2[1])));
        //} else

        if ("m_levelMax" === label) {
          levelMax = Number(cols[1]);
        } else if ("m_szCell" === label) {
          const s = cols[1].split(",");
          cellSize = new Size(Number(s[0]), Number(s[1]));
        } else if ("m_szBunkatu" == label) {
          const s = cols[1].split(",");
          splitCnt = { x: Number(s[0]), y: Number(s[1]) };
        } //if ('m_bfRectVV' == label)
      });
      this.size = size;
      this.levelMax = levelMax;
      this.cellSize = cellSize;
      this.splitCnt = splitCnt;
    } //if (arg1 instanceof Rectangle)
    /*mae
        this.cellMatrixHash = {};
        for (let level of [...Array(this.levelMax).keys()]) {
			this.cellMatrixHash[level] = 
				calcCellMatrix(this.size, this.splitCnt, this.cellSize, level)
        }
		*/
  }

  /**
   * 文字列をもとに台紙情報を生成する
   * @param value 文字列
   *
   * @description
   * 'header.txt' の内容を引数に受けることを想定している
   */
  public static parseText(value: string): PreviewDaishi {
    let size: Size = new Size(0, 0);
    let levelMax: number = 0;
    let cellSize: Size = new Size(0, 0);
    let splitCnt: { x: number; y: number } = { x: 0, y: 0 };
    //let	bfRectVV: new Rectangle(
    //			left:number,top:number,width:number,height:number);

    value.split("\n").forEach((line: string) => {
      if (line === "") return;

      line = line.trim();

      const cols: string[] = line.split(" ");
      const label: string = cols[0];

      if ("m_szDaisi" == label) {
        const s = cols[1].split(",");
        size = new Size(Number(s[0]), Number(s[1]));
      } else if ("m_levelMax" == label) {
        levelMax = Number(cols[1]);
      } else if ("m_szCell" == label) {
        const s = cols[1].split(",");
        cellSize = new Size(Number(s[0]), Number(s[1]));
      } else if ("m_szBunkatu" == label) {
        const s = cols[1].split(",");
        splitCnt = { x: Number(s[0]), y: Number(s[1]) };

        //} else if ('m_bfRectVV' == label) {
        //	const s = cols[1].split(',');
        //	bfRectVV = {x: Number(s[0]), y: Number(s[1])};
      }
    });
    return new PreviewDaishi(size, levelMax, cellSize, splitCnt);
  }

  /**
   * 指定されたサイズ の画像クリップする場合に
   * どのレベルを採用するべきかを算出する
   *
   * @param target
   */

  //turget levelを決定する
  public getLevel(tR: Rectangle, fR: Rectangle): number {
    let level = 0;
    //1.3倍表示まで許容する。値が大きくなれば、スピード優先(Top levelよりの使用)
    const ratio = 1.3;
    let ratio_indicate = tR.width / (fR.width * ratio); //拡大率
    let ratio_level = 2.0; //t/f levelMax:1 - levelMax-1:1/2 - levelMax-2:1/4 ---
    for (let l: number = this.levelMax; l >= 0; --l) {
      ratio_level /= 2;
      if (ratio_level < ratio_indicate) {
        level = l;
        break;
      }
    } //for

    return level;
  }

  public setTlast(r: Rectangle): void {
    this.tFrameLast = r;
  }
  public setFlast(r: Rectangle): void {
    this.fFrameLast = r;
  }
  public getTlast(): Rectangle {
    return this.tFrameLast;
  }
  public getFlast(): Rectangle {
    return this.fFrameLast;
  }

  //
  public sizeTateYokoDown(rF: Rectangle, rT: Rectangle): Rectangle {
    let rTNew = new Rectangle(0, 0, 0, 0);
    let szT = rT.size;
    let szF = rF.size;
    let dF = szF.cy / szF.cx;
    let dT = szT.cy / szT.cx;
    if (this.equalDouble(dF, dT)) {
      return rTNew; //Null return
    }
    //dF=szT.cy/szT.cxになるようにszT.cxかszT.cyを縮小して、ptTを移動する
    let px = rT.left;
    let py = rT.top;
    let width = rT.width;
    let height = rT.height;

    let szT_cx = szT.cy / dF; //rFと同じ縦長度でrTを見直す

    if (szT_cx > szT.cx) {
      //cxが拡大されていたらcyを縮小し直す
      let szT_cy = szT.cx * dF;
      py += (szT.cy - szT_cy) / 2.0;
      height = szT_cy;
    } else {
      px += (szT.cx - szT_cx) / 2.0;
      width = szT_cx;
    }
    rTNew = new Rectangle(px, py, px + width, py + height);
    return rTNew;
  }

  getCellsu(level: number): Size {
    let cx = Math.pow(2, level) * this.splitCnt.x; //2**level * splitCnt.cx
    let cy = Math.pow(2, level) * this.splitCnt.y; //2**level * splitCnt.cy
    let sz = new Size(cx, cy);
    return sz;
  }

  getLevelBorderSize(level: number): Size {
    //
    let suCell = this.getCellsu(level);
    let dx = this.cellSize.cx * suCell.cx;
    let dy = this.cellSize.cy * suCell.cy;
    return new Size(dx, dy);
  }

  /**
   * 指定されたサイズ の画像クリップする場合に
   * どのレベルを採用するべきかを算出する
   *
   * @param target
   */

  //public getLevel(target: Size): number {
  //		return _determineLevel(
  //  this.magnificationBuffer,
  //  this.levelMax,
  //  this.size,
  //  target);
  //}

  /**
   * 初期表示時のフレーム一覧を返却する
   * @param displayRect 出力先の矩形領域
   */
  public initialFrameList(
    displayRect: Rectangle,
  ): [Rectangle, FrameLevelCellid[]] {
    //TODO とりあえずの実装
    /*original code
        const sourceRect = displayRect;
			return [sourceRect, this.frameList(displayRect, souceRect)];
		*/
    //Code(19.10.14)
    let w = this.size.cx * this.splitCnt.x;
    let h = this.size.cy * this.splitCnt.y;
    const sourceRect = new Rectangle(new Point(0, 0), w, h);
    return this.frameList(displayRect, sourceRect);
  }

  /**
   * 指定された矩形領域を表示するためのフレーム一覧を返却する
   * @param displayRect 出力先の矩形領域
   * @param sourceRect 元の矩形領域
   */
  frameList(
    tFrame: Rectangle,
    fFrame: Rectangle,
  ): [Rectangle, FrameLevelCellid[]] {
    console.log(`frameList{tFrame:${tFrame} fFrame:${tFrame}}`);
    let frames: FrameLevelCellid[] = [];
    let border = new Rectangle(0, 0, 0, 0);

    //1.縦横調整 tFrameを縮小して調整		 -> rTNew
    let tFrameNew = this.sizeTateYokoDown(fFrame, tFrame); //1.1
    if (tFrameNew.isRectNull()) {
      tFrameNew = new Rectangle(tFrame);
    }
    //rTNew <-- rF に投影

    //fFrameIntersect fFrameを台紙DBのborderでclipping
    let fFrameIntersect = new Rectangle(fFrame);
    let www = this.size.cx * this.splitCnt.x;
    let hhh = this.size.cy * this.splitCnt.y;
    let bfRect = new Rectangle(new Point(0, 0), www, hhh);
    fFrameIntersect = fFrameIntersect.intersection(bfRect); //1.2

    //fFrameIntersectが変更されたときは、tFrameNewに反映させる
    if (!fFrameIntersect.equals(fFrame)) {
      //let trWL= new TrWL(rTNew , rF);
      let trWL = new TrWL(fFrameIntersect, bfRect);
      tFrameNew = trWL.getWorld(fFrameIntersect);
    }
    //tFrameNew <-- fFrameIntersect に投影

    this.setTlast(tFrameNew);
    this.setFlast(fFrameIntersect);

    //2.turgetLevelを決定
    let level = this.getLevel(tFrameNew, fFrameIntersect); //2.1

    //3.fFrame_level levelMax上のbfRectをturgetLevelに投影
    let r2 = new Rectangle(new Point(0, 0), this.getLevelBorderSize(level)); //3.2
    let trVL = new TrWL(bfRect, r2);
    let fFrame_level = trVL.getLocal(fFrameIntersect); //3.3

    //4.fFrame_levelをcellで分割cell_TL(x1,x2)-cell_BR(x2,y2)　x1<=  <x2
    let cxx = fFrame_level.left / this.cellSize.cx;
    let cx = Math.floor(cxx);
    let cy = Math.floor(fFrame_level.top / this.cellSize.cy);
    let cell_TL = new Size(cx, cy); //4.1 切り捨て
    let xx: number, yy: number;
    {
      let x1 = fFrame_level.right; //4.2
      let x2 = this.cellSize.cx; //4.3
      let xxx = x1 / x2;
      xx = Math.ceil(xxx); //4.4
      //xx= (x1 / x2) + (((x1 % x2) > 0)?(1):(0));	//4.4
      let y1 = fFrame_level.bottom; //4.5
      let y2 = this.cellSize.cy; //4.6
      yy = Math.ceil(y1 / y2); //4.7
      //yy= (y1 / y2) + (((y1 % y2) > 0) ? (1) : (0));	//4.7
    }
    let cell_BR = new Size(xx, yy); //4.8 切上げ

    //5. LCTF_LIST(LevelID,CellID,To,From)作成
    //   cell_TL,cell_BRから、cell一覧を処理
    //18.8.18 LCTF_LIST	list;
    let cellsu_level = this.getCellsu(level); //5.1
    for (let y = cell_TL.cy; y < cell_BR.cy; ++y) {
      for (let x = cell_TL.cx; x < cell_BR.cx; ++x) {
        let cellID = new Point(x, y);

        //6.cellの受け持つfrom領域(Level空間)を求める
        let cellRect_level: Rectangle; //cellの受け持つfrom領域(Level空間)
        {
          let sz = new Size(this.cellSize);
          let p = new Point(sz.cx * cellID.x, sz.cy * cellID.y);
          cellRect_level = new Rectangle(p, sz); //6.1
          //TRACE("%s\n", cellRect_level.ToString("cellRect_level"));
        }

        //7.cellの受け持つfrom領域(LevelMax空間:FR空間)
        let cellRect_viewDB = trVL.getWorld(cellRect_level); //7.1

        //8.cellの受け持つto領域(Window空間)
        let trTF = new TrWL(tFrameNew, fFrameIntersect);
        let cellRect_window = trTF.getWorld(cellRect_viewDB); //8.1

        //9.cellRect_windowをtFrameでClipping
        let cellRect_windowClipping = cellRect_window.intersection(tFrameNew);
        if (cellRect_windowClipping.isRectNull()) {
          //9.1
          continue;
        }

        //10.cellRect_viewDBN,cellRect_levelNに投影する
        let cellRect_viewDBN = new Rectangle(cellRect_viewDB);
        let cellRect_levelN = new Rectangle(cellRect_level);
        if (cellRect_windowClipping != cellRect_window) {
          //Clippingにより変更された?
          cellRect_viewDBN = trTF.getLocal(cellRect_windowClipping);
          cellRect_levelN = trVL.getLocal(cellRect_viewDBN);
        } //10.1

        //11.リストに追加
        let from = cellRect_levelN;
        let topLeft = from.topLeft;
        topLeft.round();
        let szCell = this.cellSize;

        //if((topLeft != new Point(0,0))||(from.size != this.cellSize)){//***
        if (!topLeft.equals(new Point(0, 0)) || !from.size.equals(szCell)) {
          //***
          let x = topLeft.x;
          while (x >= szCell.cx) {
            x -= szCell.cx;
          }
          let y = topLeft.y;
          while (y >= szCell.cy) {
            y -= szCell.cy;
          }
          topLeft = new Point(x, y);

          from = new Rectangle(topLeft, from.size); //cell offsetに変更
        } //*********************************
        from.round();
        let to = cellRect_windowClipping;
        to.round();
        console.log(`cellID:${cellID} to:${to} from:${from}`);
        console.log(`topLeft:${topLeft} szCell:${szCell}`);
        if (!to.isRectEmpty() && !from.isRectEmpty()) {
          /*{
					let	x1= topLeft.x + from.width;
					let	x2= szCell.cx;
					let	x3= 760;
					console.log(x1<=x2);
					console.log(x1<=x3);
					let	y1= topLeft.y + from.height;
					let	y2= szCell.cy;
					let	y3= 744;
					console.log(y1 <= y2);
					console.log(y1 <= y3);
					}*/
          if (
            topLeft.x + from.width <= szCell.cx &&
            topLeft.y + from.height <= szCell.cy
          ) {
            //19.10.17 let	cellid= new Point(1,1);
            //19.10.18 let	fromNew= new Rectangle(0,0,864,624);
            frames.push(new FrameLevelCellid(level, cellID, to, from)); //11.1
            //list.AddTail(new LCTF(level, cellID, to, from));	//************
            border = border.unionRectWith(cellRect_windowClipping);
          } else {
            console.log(`skip{level:${level} cellID:${cellID}}`);
          } //if (((topLeft.x + from.Width()) <= (szCell.cx))
        } //if ((!to.IsRectEmpty())&&(!from.IsRectEmpty()))
      } //for(int x
    } //for(int y

    return [border, frames];
  }

  //
  equalDouble(d1: number, d2: number): boolean {
    if (d1 > d2) {
      let d = d1 - d2;
      if (d1 - d2 < d1 / 1000) {
        return true;
      } else {
        return false;
      }
    } else {
      if (d2 - d1 < d2 / 1000) {
        return true;
      } else {
        return false;
      }
    }
  }
} //class PreviewDaishi

/**
 * レベルに応じたセル情報を算出する。
 * セル情報は 縦 x 横 の２次元配列にて返却される。
 * @param size
 * @param splitCnt
 * @param cellSize
 * @param level
 */
//export function calcCellMatrix(
//    size: Size, splitCnt: { x: number; y: number },
//    cellSize: Size, level: number): Cell[][] {

//    let list: Cell[][] = [];
//    const cellNumber: { x: number, y: number } = _calcCellNumber(splitCnt, level);

//    // ↓ 右記と同じ for (let x = 0; x < cellNumber.x; x++) {
//    for (let x of [...Array(cellNumber.x).keys()]) {
//        let inner: Cell[] = [];
//        for (let y of [...Array(cellNumber.y).keys()]) {
//            const left = (size.width / cellNumber.x) * x;
//            const top = (size.height / cellNumber.y) * y;
//            const right = (size.width / cellNumber.x) * (x + 1);
//            const bottom = (size.height / cellNumber.y) * (y + 1);
//            inner.push(
//                new Cell(level,
//                    new Point(x, y),
//                    new Rectangle(left, top, right, bottom))
//            );
//        }
//        list.push(inner);
//    }
//    return list;
//}

/**
 * レベルに応じた縦横セル数を算出する
 * @param splitCnt 分割数
 * @param level 深度
 *
 * @description
 * CMyViewDB::GetCellsu から移植
 * https://github.com/sharaku-software/sdesktop/blob/master/sLib/MyViewDB.cpp#L320
 */
/**mae
export function _calcCellNumber(splitCnt: { x: number, y: number }, level: number): { x: number, y: number } {
    return {
        x: Math.floor(Math.pow(2, level) * splitCnt.x + 0.5),
        y: Math.floor(Math.pow(2, level) * splitCnt.y + 0.5)
    };
}
*/

/**
 * レベルを判定する
 * @param magnificationBuffer
 * @param levelMax
 * @param sourceSize
 * @param clipSize
 */
/*mae
export function _determineLevel(
    magnificationBuffer: number, levelMax: number,
    sourceSize: Size, clipSize: Size): number {

    const sw = sourceSize.width * magnificationBuffer;
    const dw = clipSize.width;
    const level = Math.floor(Math.log2(sw * 2 / dw));
    return level > levelMax ? levelMax : level;
}
*/
